const getBookCoverUrl = (id, size = 'L') => {
    if(id) return `https://covers.openlibrary.org/b/id/${id}-${size.toUpperCase()}.jpg`;

    return false;
};

export default getBookCoverUrl;